export default {
      id: "404-usage",
      viewBox: "0 0 128 128",
      url: __webpack_public_path__ + "img/icons.d00d1db2.svg#404",
      toString: function () {
        return this.url;
      }
    }